import React, { Component } from 'react'
import { TweenMax, Back, TimelineMax, Power2, Power4, Sine } from 'gsap';
import ScrollMagic from 'scrollmagic';
//require('ScrollMagicGSAP');
//import ScrollMagic from '../../ScrollMagic';
export default class componentName extends Component {

    componentDidMount(){
        var controller = new ScrollMagic.Controller({
            globalSceneOptions: {
             
              addIndicators: true
            }
          });

          TweenMax.set(this.divProjectImageCon, {
            transformPerspective: 900
        })


          /*
          .to(this.divProjectImageCon, 1, {
            webkitClipPath: 'inset(0% 0%)',
            clipPath: 'inset(0% 0%)',
            opacity:1,
            left:'60px',
            ease: Power2.easeOut,
        })
          */ 

          var tm = new TimelineMax();
          tm.from(this.divProjectImageCon, 1, {
            rotationX: 20,
            transformOrigin: "center top",
            ease: Power2.easeOut
          }).to(this.divProjectImageBg, 0.6, {
            opacity:1,
            ease: Power2.easeOut,
            
            left:'140px'
        })

        new ScrollMagic.Scene({
            triggerElement: this.divCon,
            triggerHook: 'onEnter',
            duration: "0%"
        }).setTween(tm).addTo(controller);
    }

  render() {
    return (
        <div className="home-recent--project" style={{ flexDirection: this.props.oppsiteStyle ? 'row-reverse' : 'row'  }} ref={e=> this.divCon = e}>
            <div className="home-recent--project--image">
                <div className="home-recent--project--image--con" ref={e => this.divProjectImageCon = e}>
                    <img src="http://studiogritt.com/media/gallery/7_NTZEMeC.jpg" />
                </div>
                <div className="home-recent--project--image--bg" ref={e => this.divProjectImageBg = e}></div>
            </div>
            <div className="home-recent--project--details-wrap">
                <div>
                    <span className="home-recent--project--details--name">Media IQ</span>
                    <span className="home-recent--project--details--type">Interiors and Construction</span>
                    <span className="home-recent--project--details--para">You may also be interested in react-transition-group-plus, a drop-in replacement for ReactTransitionGroup that allows interruptible transitions and specifying transition order. See a comparative demo here.</span>
                    <div style={{ marginTop:'42px' }}>
                        <div className="sg-button">
                            SEE THIS STORY
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/HomeFeatWorkWrapper/index.js